import { render } from "./WinnersCard.vue?vue&type=template&id=757a84ae"
import script from "./WinnersCard.vue?vue&type=script&lang=js"
export * from "./WinnersCard.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__